import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  paperHeightXs: {
    minHeight: '256px',
    maxHeight: 'min(calc(100vh - 48px), 564px)',
  },
  paperHeightSm: {
    minHeight: '380px',
    maxHeight: 'min(calc(100vh - 48px), 804px)',
  },
  paperHeightMd: {
    minHeight: '504px',
    maxHeight: 'min(calc(100vh - 48px), 804px)',
  },
  paperHeightLg: {
    minHeight: '504px',
    maxHeight: 'min(calc(100vh - 48px), 804px)',
  },
}));

export default useStyles;
